<template>
  <div>
    <div class="pa-6">
      <v-container fluid>
        <v-row>
          <v-col class="yCenter">
            <h2 class="primary--text pr-5">{{ pageTitle }}</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <CsvHistoryHeader
              @updateInput="updateInput"
              @invalidDisplayFlg="updateInvalidDisplayFlg"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <CsvHistoryList
              itemKey="csvId"
              isOperation="ture"
              :headers="csvHistoryHeaders"
              :productListHeaders="csvHistoryProductListHeaders"
              :historyList="historyList"
              :hiddenHeaderOperation="true"
              :isCheckedAllSelect="isCheckedAllSelect"
              @changeProductTableCheckbox="changeProductTableCheckbox"
              @allCheckProductTable="allCheckProductTable"
              @pageReload="init"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CsvHistoryHeader from './CsvHistoryHeader'
import { CsvHistoryList } from '@/components/layouts'
import CsvHistoryHeaders from './headers'
import _cloneDeep from 'lodash/cloneDeep'
import { commonUtil, customerUtil } from '@/util'
import { i18n } from '@/main.js'

export default {
  components: {
    CsvHistoryHeader,
    CsvHistoryList
  },
  data: () => {
    return {
      pageTitle: i18n.tc('common.common_csv-history-view'),
      invalidDisplayFlg: true,
      inputData: {},
      historyList: [],
      isCheckedAllSelect: false,
      isCheckedAllSelects: []
    }
  },
  computed: {
    ...mapGetters('FileStore', ['getCsvUploadHistoryListFromState']),
    csvHistoryHeaders() {
      return CsvHistoryHeaders.headers
    },
    csvHistoryProductListHeaders() {
      return CsvHistoryHeaders.productListHeaders
    }
  },
  async created() {
    this.setIsLoading(true)
    await this.getJdproductListFromApi()
    await customerUtil.getCustomer()
    this.setIsLoading(false)
    // const params = {
    //   platformId: '1'
    // }
    // const data = await this.externalSystemCsvUploaded(params)
    // console.log(data)
    // await this.init()
  },
  methods: {
    ...mapActions('FileStore', ['externalSystemCsvUploaded']),
    ...mapActions('Jdproduct', ['getJdproductListFromApi']),
    ...mapActions('Common', ['setIsLoading']),
    async init() {
      this.setIsLoading(true)
      const params = this.getParam()
      await this.externalSystemCsvUploaded(params)

      this.isCheckedAllSelects = []

      this.historyList = _cloneDeep(this.getCsvUploadHistoryListFromState)
        .sort((a, b) => {
          const keyName = 'exCsvFileId'
          if (a[keyName] < b[keyName]) return 1
          if (a[keyName] > b[keyName]) return -1
          return 0
        })
        .map((ele, Index) => {
          ele.exCsvFileDetailList.map((ele2) => {
            ele2.isCheck = false
          })
          ele.panelIndex = Index + 1

          this.isCheckedAllSelects.push({
            id: ele.exCsvFileId,
            isChecked: false
          })
          return ele
        })
      this.setIsLoading(false)
    },
    async updateInput(item) {
      this.inputData = item
      await this.init()
    },
    getParam() {
      return {
        // platformIdは固定値
        platformCountryId: commonUtil.nullEmptyFormatNull(
          this.inputData.platformId?.value
        ),
        uploadedDateFrom: commonUtil.nullEmptyFormatNull(
          this.inputData.uploadDate.start
        ),
        uploadedDateTo: commonUtil.nullEmptyFormatNull(
          this.inputData.uploadDate.end
        ),
        status: this.inputData.status,
        showEnableOnly: this.invalidDisplayFlg ? 1 : 0
      }
    },
    changeProductTableCheckbox() {
      this.historyList.forEach((each) => {
        // 要修正
        let allCheck = true
        each.exCsvFileDetailList.forEach((each2) => {
          if (!each2.isCheck) {
            allCheck = false
          }
        })
        this.isCheckedAllSelects.map((ele) => {
          if (ele.id === each.exCsvFileId) ele.isChecked = allCheck
        })
      })
    },
    allCheckProductTable(exCsvFileId) {
      let isChecked = false
      this.isCheckedAllSelects.map((ele) => {
        if (ele.id == exCsvFileId) {
          isChecked = !ele.isChecked
          ele.isChecked = isChecked
        }
      })
      this.historyList
        .find((ele) => ele.exCsvFileId === exCsvFileId)
        .exCsvFileDetailList.forEach((each) => {
          this.$set(each, 'isCheck', isChecked)
        })
    },
    async updateInvalidDisplayFlg(flg) {
      this.invalidDisplayFlg = flg
      await this.init()
    }
  }
}
</script>

<style scoped lang="scss">
.titleStyle {
  font-size: 18px;
  font-weight: bold;
}
.resultTitleStyle {
  font-size: 15px;
  font-weight: bold;
}
.uploadResultTextStyle {
  font-size: 14px;
  font-weight: bold;
}
.headerAreaStyle {
  height: 70px;
}
.resultHeaderAreaStyle {
  height: 50px;
}
label > input {
  display: none;
}
label {
  padding: 5px 10px;
  border-radius: 4px;
  border: solid 1px #c8cfd7;
  background-color: #fff;
}
.selectboxStyle {
  max-width: 261px;
}
.textButtonStyle {
  margin: 0px 21px;
  ::v-deep .v-btn {
    font-size: 12px;
  }
}
.uploadResultTextButtonStyle {
  ::v-deep .v-btn {
    padding: 0;
    font-size: 14px;
  }
}
</style>
